// src/Au.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Au_default = createIcon({
  displayName: "Au",
  viewBox: "0 0 51 34",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "blue dark", x: "1.5", y: "1", width: "48", height: "32", fill: "#0070B8" }),
    /* @__PURE__ */ jsxs("g", { id: "UK corner", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "blue dark_2",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.5 1V17H25.5V1H1.5Z",
          fill: "#0070B8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "white",
          d: "M4.20416 1L25.5 15.1972V17H22.7958L1.5 2.80278L1.5 1L4.20416 1Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "white_2",
          d: "M4.20416 17L25.5 2.80278V1L22.7958 1L1.5 15.1972L1.5 17H4.20416Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { id: "red", d: "M1.5 1V2.20185L11.6972 9H13.5L1.5 1Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_2", d: "M13.5 9V7.79815L23.6972 1H25.5L13.5 9Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_3", d: "M25.5 17V15.7981L15.3028 9H13.5L25.5 17Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx("path", { id: "red_4", d: "M1.5 17L13.5 9V10.2019L3.30278 17H1.5Z", fill: "#FF1A26" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "white cross",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 1H11V6.5H1.5V11.5H11V17H16V11.5H25.5V6.5H16V1Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          id: "red cross",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 1H12V7.5H1.5V10.5H12V17H15V10.5H25.5V7.5H15V1Z",
          fill: "#FF1A26"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "star",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38 6L38.3506 7.12362L39.4216 6.7056L38.7879 7.6887L39.7727 8.29106L38.6318 8.39335L38.7889 9.5625L38 8.70695L37.2111 9.5625L37.3682 8.39335L36.2273 8.29106L37.2121 7.6887L36.5784 6.7056L37.6494 7.12362L38 6ZM42.7273 10.75L43.0779 11.8736L44.1489 11.4556L43.5152 12.4387L44.5 13.0411L43.3591 13.1434L43.5162 14.3125L42.7273 13.457L41.9383 14.3125L42.0954 13.1434L40.9545 13.0411L41.9394 12.4387L41.3057 11.4556L42.3766 11.8736L42.7273 10.75ZM33.2727 11.9375L33.6234 13.0611L34.6943 12.6431L34.0606 13.6262L35.0455 14.2286L33.9046 14.3309L34.0617 15.5L33.2727 14.6445L32.4838 15.5L32.6409 14.3309L31.5 14.2286L32.4848 13.6262L31.8511 12.6431L32.9221 13.0611L33.2727 11.9375ZM38 21.4375L38.3506 22.5611L39.4216 22.1431L38.7879 23.1262L39.7727 23.7286L38.6318 23.8309L38.7889 25L38 24.1445L37.2111 25L37.3682 23.8309L36.2273 23.7286L37.2121 23.1262L36.5784 22.1431L37.6494 22.5611L38 21.4375ZM39.7727 15.5L40.038 16.4193H40.9545L40.231 16.9812L40.4963 17.875L39.7727 17.3132L39.0492 17.8494L39.3145 16.9812L38.5909 16.4193H39.4833L39.7727 15.5Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "star_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 22L13.6923 24.2078L15.8068 23.3864L14.5556 25.3182L16.5 26.5017L14.2475 26.7027L14.5576 29L13 27.3189L11.4424 29L11.7525 26.7027L9.5 26.5017L11.4444 25.3182L10.1932 23.3864L12.3077 24.2078L13 22Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.5 1V0H0.5V1H1.5ZM49.5 1H50.5V0H49.5V1ZM49.5 33V34H50.5V33H49.5ZM1.5 33H0.5V34H1.5V33ZM1.5 2H49.5V0H1.5V2ZM48.5 1V33H50.5V1H48.5ZM49.5 32H1.5V34H49.5V32ZM2.5 33V1H0.5V33H2.5Z",
        fill: "#F3F6F9"
      }
    )
  ] })
});

export {
  Au_default
};
